import { Component, Input, OnInit, SimpleChanges, AfterViewInit, OnDestroy, OnChanges } from '@angular/core';
import { Chart, registerables } from 'chart.js';
import { DonutChartConfig } from '../../types/chart-types';

@Component({
    selector: 'app-doughnut-chart',
    templateUrl: './doughnut-chart.component.html',
    styleUrls: ['./doughnut-chart.component.scss'],
    standalone: false
})
export class DoughnutChartComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  @Input() colors: string[] = [];
  @Input() data: number[] = [];
  @Input() description: string = "";
  @Input() secondaryDescription: string = "";
  @Input() label: string = "";
  @Input() customMiddleText: string = ""
  @Input() unique_id:string = "";
  @Input() containerWidth: number | string = "auto";
  @Input() chartConfig : DonutChartConfig = {};


  chart: Chart<"doughnut", number[], unknown> | undefined;
  config!: DonutChartConfig;


  constructor() {
    Chart.register(...registerables); // Register necessary components
  }

  ngOnInit(): void {
    this.config = {
      customFontSize: false,
      middleTextFontSize: 2,
      middleTextFontColor: "#000000",
      rotation: -90,
      circumference: 180,
      aspectRatio: 2,
      cutout: "80%",
      borderRadius: 0,
      ...this.chartConfig
    }
  }

  ngOnChanges(changes: SimpleChanges) {
     if(changes['data'] && changes['customMiddleText']) {
      this.updateChart();
     }
  }

  ngAfterViewInit() {
    this.implementDoughnutChart();
  }

  ngOnDestroy() {
    this.chart?.destroy();
  }

  private implementDoughnutChart(): void {
    const canvas = document.getElementById('base-doughnut-chart-'+this.unique_id);
    if (canvas != null && canvas instanceof HTMLCanvasElement) {
      const ctx = canvas.getContext('2d');
      if (ctx == null) {
        throw new Error('Cannot get 2d context from canvas');
      }

      const self = this; // Create a reference to the component's this context

      this.chart =  new Chart(ctx, {
        type: 'doughnut',
        data: {
          datasets: [{
            data: this.data,
            backgroundColor: this.colors,
            borderRadius: this.config.borderRadius,
          }],
        },
        options: {
          rotation: this.config.rotation,
          circumference: this.config.circumference,
          responsive: true,
          aspectRatio: this.config.aspectRatio,
          cutout: this.config.cutout,
          plugins : {
            tooltip : {
              enabled : false
            }
          },
          events : [],
        },
        plugins : [
          {
            id: "midText",
            beforeDraw: function(chart,args) {
              var width = chart.width,
                  height = chart.height,
                  ctx = chart.ctx;



              ctx.restore();
              var fontSize = self.config.customFontSize ? self.config.middleTextFontSize: (height / 60).toFixed(2);
              ctx.font ="300 " + fontSize + "em Roboto";
              ctx.textBaseline = "middle";

              var textYOffset = self.config.customFontSize ? (height / 2 + 8) : (height - 20);
              var text = self.customMiddleText,
                  textX = Math.round((width - ctx.measureText(text).width) / 2),
                  textY = textYOffset;

              ctx.fillText(text, textX, textY);
              ctx.save();
            }
          }
        ]
      });
    }
  }

  private updateChart(): void {
    if (this.chart) {
      this.chart.data.datasets[0].data = this.data;
      this.chart.update();
    } else {
      this.implementDoughnutChart();
    }
  }

  private createDoughnutChart(): void {
    // You can add any additional configuration here if needed
  }
}
